module.exports = __webpack_public_path__ + "img/kinara_logo.f5670fd9.svg";